// extracted by mini-css-extract-plugin
export default {"expiredStepWrapper":"ExpiredStep_expiredStepWrapper__Euk49","title":"ExpiredStep_title__7jFaA","text":"ExpiredStep_text__i4q7g","warningIcon":"ExpiredStep_warningIcon__vDz2J"};